function sortPlanningEventsByMachineCategory(events = [], machines = []) {
    const categoryByMachine = new Map(
        machines.map(({ machine, category }) => [String(machine || '').trim(), Number(category)])
    );

    return events
        .map((event, originalIndex) => {
            const machineNo = String(event.machineNo || '').trim();
            const lineNo = String(event.lineNo || '').trim();
            const selectedMachine = machineNo || lineNo;
            const category = categoryByMachine.get(selectedMachine);
            return { event, originalIndex, selectedMachine, category };
        })
        .sort((left, right) => {
            const leftMatched = Number.isFinite(left.category);
            const rightMatched = Number.isFinite(right.category);
            if (leftMatched !== rightMatched) return leftMatched ? -1 : 1;
            if (!leftMatched) return left.originalIndex - right.originalIndex;
            if (left.category !== right.category) return left.category - right.category;
            const nameOrder = left.selectedMachine.localeCompare(right.selectedMachine);
            return nameOrder || left.originalIndex - right.originalIndex;
        })
        .map(({ event }) => event);
}

module.exports = { sortPlanningEventsByMachineCategory };
